import { render, staticRenderFns } from "./CentroMultidisciplinarComponente.vue?vue&type=template&id=1a5ab272&scoped=true"
import script from "./CentroMultidisciplinarComponente.vue?vue&type=script&lang=js"
export * from "./CentroMultidisciplinarComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroMultidisciplinarComponente.vue?vue&type=style&index=0&id=1a5ab272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ab272",
  null
  
)

export default component.exports